export type Params = {
  id: string;
  page: number;
  per_page: number;
  search: string;
  sort: string;
  sort_direction: string;
};

export type Response = {
  total_count: number;
  total_pages: number;
  per_page: number;
  current_page: number;
};

export const defaults: Partial<Params> = {
  page: 1,
  per_page: 1000,
  sort_direction: "ASC",
};

export const BASE = "/api/v2/"; // just to see if jenkis is happy...

export enum PATH {
  authorizations = `/api/v2/authorizations`,
  memberships = `/api/v2/memberships`,
  projects = `/api/v2/projects`,
  groups = `/api/v2/groups`,
  roles = `/api/v2/roles`
}

export const isValidQueryLength = (query: string) => query && query.length >= 2;
